import { render, staticRenderFns } from "./DoorLockDamage.vue?vue&type=template&id=1d5e63ef&scoped=true"
import script from "./DoorLockDamage.vue?vue&type=script&lang=ts"
export * from "./DoorLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e63ef",
  null
  
)

export default component.exports